// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"LanguageSwitcher_languageSwitcher__FMJ1R"};